<style scoped>
.badge-container {
  position: relative;
}

.alert-badge {
  position: absolute !important;
  border-radius: 9999px;
  z-index: 999;
}

.alert-badge-position-relative {
  position: relative !important;
}

</style>

<template>
  <div class="badge-container" >
    <b-badge
      v-show="show"
      v-if="!(this.text === 0 || this.text === '0')"
      class="alert-badge"
      :class="{ 'alert-badge-position-relative': position === 'relative' }"
      :style="{
        right: `${this.xOffset}px`,
        top: `-${this.yOffset}px`,
      }"
      :variant="variant"
    >
      <slot name="badge">{{text}}</slot>
    </b-badge>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    text: [String, Number],
    variant: {
      type: String,
      default: 'danger',
    },
    xOffset: {
      type: [String, Number],
      default() { return -5; },
    },
    yOffset: {
      type: [String, Number],
      default() { return 5; },
    },
    position: {
      type: String,
      default: 'absolute',
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/Badge.vue